<template>
  <div>
    <collector />
    <ProcessingCluster/>
    <ApiKey />
  </div>
</template>
<script>
import ApiKey from '@/components/ApiKey/Api_key'
import Collector from '@/components/Collector/Collector'
import ProcessingCluster from '@/components/ProcessingCluster/Processing_Cluster'
export default {
  name: 'Utilities',
  components: {
    ApiKey,
    Collector,
    ProcessingCluster
  },
  mounted () {
    this.$mixpanel.track('Utilities Screen Opened')
  }
}
</script>
